<template>
    <div>
        <!-- Prestadores -->
        <div class="form-row">
            <div class="col col-12 col-md-9">
                <az-input
                    sizing="sm"
                    icon="fa fa-search fa-fw"
                    v-model="search">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="medicos && medicos.length">
                            <span class="input-group-text" id="basic-addon2">
                                {{ selecionados }}/{{ medicos.length }}
                            </span>

                            <button type="button" class="btn btn-outline-secondary" title="Definir tempo" @click="editar_tempos()">
                                <i class="far fa-clock"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-primary btn-sm mb-3" @click="marcar_todos_medicos()">
                    Todos
                </button>
            </div>
        </div>

        <div v-if="!medicos || !medicos.length">
            <az-empty-state msg="Nenhuma médico registrado." />
        </div>

        <template v-else>

            <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between" v-for="(medico, im) in lista" :key="im">
                    <div>
                        <input class="mr-3" type="checkbox" 
                            v-model="medico.medico_procedimento_unidade.fl_ativo" 
                            id="defaultCheck1">
                        <label class="form-check-label" for="defaultCheck1">
                            <a href="#" class="card-link" @click.prevent="$util.abrirMedico (medico.medico)">
                                {{ medico.medico.search }}
                            </a>
                        </label>
                    </div>
                    <div class="d-flex">
                        <span v-if="medico.medico.js_classes">
                            <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in medico.medico.js_classes" :key="icx">
                                <span class="badge badge-success ml-1" >
                                    {{ classe }}
                                </span>
                            </a>
                        </span>

                        <span>
                            <span class="badge ml-2" 
                                :class="!medico.agendas_count 
                                    ? 'badge-danger' 
                                    : ( !medico.agendas_proc_count ? 'badge-warning' : ( medico.agendas_count == medico.agendas_proc_count ? 'badge-success' : 'badge-info' ) )"
                                v-if="medico.medico_procedimento_unidade.fl_ativo" 
                                data-toggle="tooltip" data-placement="top"
                                title="Agendas com esse procedimento vs Total de Agendas">
                                {{ medico.agendas_proc_count }}/{{ medico.agendas_count }} 
                            </span>
                        </span>

                        <div style="width: 200px;" v-if="medico.medico_procedimento_unidade.fl_ativo" class="ml-2">
                            <az-input 
                                sizing="sm"
                                type="number"
                                placeholder="Tempo (min)"
                                :mb="false"
                                v-model="medico.medico_procedimento_unidade.in_tempo_atendimento">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" title="Tempo de Atendimento">
                                            <i class="far fa-clock"></i>
                                        </span>
                                    </div>
                                </template>

                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <span class="input-group-text">
                                            min
                                        </span>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                    </div>
                </li>
            </ul>

            <div class="mt-3">
                <az-submit color="outline-success mr-1" @click="alterar_agendas(true)" v-if="id_procedimento">
                    Incluir nas Agendas
                </az-submit>

                <az-submit color="outline-danger" @click="alterar_agendas(false)" v-if="id_procedimento">
                    Remover das Agendas
                </az-submit>
            </div>

        </template>

        
        <!-- Modal Definição de Tempo -->
        <div class="modal fade" id="tempoAtendimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Tempo de Atendimento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input 
                            label="Tempo de Atendimento"
                            type="number"
                            placeholder="Padrão da Agenda..."
                            v-model="tempo_atendimento">

                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        min
                                    </span>
                                </div>
                            </template>

                        </az-input>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="selecionar_tempo()">Selecionar</button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data () { 
        return { 
            medicos: null, 
            search: "", 
            tempo_atendimento: "", 
        };
    },

    props: ['value', 'id_procedimento'],

    components: { 
        AzInput, 
        AzEmptyState,
        AzSubmit, 
    },

    computed: { 
        selecionados: function () { 
            if ( !this.medicos )
                return 0;

            return this.medicos.filter(medico => medico.medico_procedimento_unidade.fl_ativo).length;
        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return ( this.medicos && this.medicos.length ) ? 
                this.medicos.filter (item => { 
                    return ( !this.search || reg.test(JSON.stringify(item)) );
                }) 
                : [];
        },
    },

    watch: {
        medicos: { 
            handler: function (newValue) {
                this.$emit('input', newValue);
            },
            deep: true,
            immediate: true
        },

        value: {
            handler: function (newValue) {
                this.medicos = newValue;
            },
            deep: true,
            immediate: true,
        },
    },

    methods: {
        editar_tempos () { 
            $('#tempoAtendimentoModal').modal('show');
        },

        selecionar_tempo () { 
            this.lista.filter(item => item && item.medico_procedimento_unidade && item.medico_procedimento_unidade.fl_ativo)
                .forEach(item => { 
                    item.medico_procedimento_unidade.in_tempo_atendimento = this.tempo_atendimento;
                });

            $('#tempoAtendimentoModal').modal('hide');
        },
        
        filtrar (texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        alterar_agendas (incluir = true) { 
            if ( incluir ) { 
                if ( !confirm('Confirma incluir o procedimento nas agendas dos médicos selecionados?') )
                    return;
            } else { 
                if ( !confirm('Confirma remover o procedimento das agendas dos médicos selecionados?') )
                    return;
            }

            this.$util.atualizar (this, { 
                service: 'procedimentos',
                func: 'incluir_nas_agendas',
                dados: { 
                    id_procedimento: this.id_procedimento, 
                    medicos: this.lista, 
                    incluir: incluir, 
                },
                callback: res => { 
                    this.$toast.add({
                        severity: "success",
                        summary: incluir ? "Incluir nas Agendas" : "Remover das Agendas",
                        detail: !res 
                            ? 'Nenhuma alteração realizada.' 
                            : ( res > 1 ? res + " alterações realizadas." 
                                : res + " alteração realizada." ),
                        life: 3000
                    });

                    this.$emit('refresh');
                }
            });
        },

        marcar_todos_medicos () { 
            let marcar = false;

            if ( this.lista.find(medico => !medico.medico_procedimento_unidade.fl_ativo) ) { 
                marcar = true;
            }

            this.lista.forEach(medico => { 
                medico.medico_procedimento_unidade.fl_ativo = marcar;
            }); 
        },

    }

}
</script>